import { useLang } from "@/i18n/LanguageContext";

const Row = ({ items }) => (
  <div className="flex items-center shrink-0">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif-display italic text-2xl md:text-3xl text-[#1C1B18]/80 px-8 whitespace-nowrap">{item}</span>
        <span className="block w-1.5 h-1.5 bg-[#C5A059] rotate-45" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div className="overflow-hidden py-8 border-y border-[#1C1B18]/8 bg-[#F7F5F0]" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max">
        <Row items={items} />
        <Row items={items} />
      </div>
    </div>
  );
};

export default Marquee;
